import { useState } from 'react'
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native'
import { useRouter } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../lib/AuthContext'
import { colors, fonts } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'
import { Card, SectionLabel } from '../../components/Leagues/ui'
import GradientButton from '../../components/GradientButton'
import ModaleCreaLega from './ModaleCreaLega'
import ModaleUniscitiLega from './ModaleUniscitiLega'
import SezioneMembri from './SezioneMembri'
import SezioneCalendario from './SezioneCalendario'
import SezioneImpostazioni from './SezioneImpostazioni'
import SezioneInvito from './SezioneInvito'
import SezioneStatistiche from './SezioneStatistiche'
import SezionePickAdmin from './SezionePickAdmin'
import SezioneTeam from './SezioneTeam'
import { useMemo } from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

export default function LeagueSettings() {
  const { t } = useTranslation()
  const router = useRouter()
  const tc = useThemeColors()
  const styles = useMemo(() => makeStyles(tc), [tc])
  const { user, leagueId, userLeagues, switchLeague, refreshLeagues } = useAuth()
  const currentLeague = userLeagues?.find(l => l.id_league === leagueId)
  const isAdmin = currentLeague?.is_league_admin ?? false
  const insets = useSafeAreaInsets()

  const [showCrea, setShowCrea] = useState(false)
  const [showUnisciti, setShowUnisciti] = useState(false)

  const onLeagueActionSuccess = async (newLeagueId) => {
    setShowCrea(false); setShowUnisciti(false)
    await refreshLeagues?.()          // prima l'elenco aggiornato: switchLeague ricava da li' la competizione della lega
    if (newLeagueId) switchLeague(newLeagueId)
  }

  return (
    <ScrollView style={[{ flex: 1, backgroundColor: tc.bg }]} contentContainerStyle={{ padding: 16, paddingBottom: 40+ insets.bottom  }}>

      {/* Crea / Unisciti */}
      <Card style={{ marginBottom: 20 }}>
        <View style={{ flexDirection: 'row', gap: 8 }}>
          <TouchableOpacity style={[styles.joinBtn, { backgroundColor: tc.bgCard2, borderColor: tc.border }]} onPress={() => setShowUnisciti(true)} accessibilityRole="button" accessibilityLabel={t('league.index_join')}>
            <Text style={[styles.joinBtnText, { color: tc.textMuted }]}>{t('league.index_join')}</Text>
          </TouchableOpacity>
          <GradientButton onPress={() => setShowCrea(true)} style={{ flex: 1 }}>{t('league.index_create')}</GradientButton>
        </View>
      </Card>

      {/* Section label */}
      <View style={{ marginBottom: 14 }}>
        <SectionLabel>{t('league.manage_title', { name: currentLeague?.name?.toUpperCase() || t('nav.leagues').toUpperCase() })
        }</SectionLabel>
      </View>

      <SezioneMembri
        leagueId={leagueId} isAdmin={isAdmin}
        currentUserId={user?.id} memberCount={currentLeague?.member_count || 0}
        onMembersChange={(action) => { refreshLeagues?.(); if (action === 'leave') router.replace('/Leagues') }}
      />
      <SezioneCalendario leagueId={leagueId} isAdmin={isAdmin} />
      <SezioneImpostazioni
        leagueId={leagueId} isAdmin={isAdmin}
        leagueName={currentLeague?.name}
        leagueIsPublic={currentLeague?.is_public}
        onSettingsChange={() => refreshLeagues?.()}
      />
      <SezioneInvito leagueId={leagueId} leagueName={currentLeague?.name} isAdmin={isAdmin} />
      <SezioneStatistiche leagueId={leagueId} />
      <SezionePickAdmin leagueId={leagueId} isAdmin={isAdmin} />
      {currentLeague?.team_race && (
        <SezioneTeam
          leagueId={leagueId}
          userId={user?.id}
          teamRace={currentLeague?.team_race ?? false}
          teamMember={currentLeague?.team_member ?? 2}
        />
      )}

      <ModaleCreaLega visible={showCrea} userId={user?.id} onClose={() => setShowCrea(false)} onSuccess={onLeagueActionSuccess} />
      <ModaleUniscitiLega visible={showUnisciti} userId={user?.id} onClose={() => setShowUnisciti(false)} onSuccess={() => { refreshLeagues?.(); setShowUnisciti(false) }} />
    </ScrollView>
  )
}

const makeStyles = (tc) => StyleSheet.create({
  joinBtn: { flex: 1, minHeight: 44, justifyContent: 'center', borderRadius: 8, borderWidth: 1, padding: 10, alignItems: 'center' },
  joinBtnText: { fontFamily: fonts.condensedBold, fontSize: 14 },
})
